function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Button, Space, Divider, Modal, message, Card, Statistic, Tag, Collapse, Drawer, Tabs, Table } from "antd";
import AddRoom from '../components/forms/AddRoom';
import { Icon } from "@iconify/react";
import { useParams } from "react-router-dom";
import AddBed from '../components/forms/AddBed';
import Common from '../components/includes/Common';
import { DoorOpenFill, Clipboard2Pulse, CashStack } from 'react-bootstrap-icons';
import Care from '../components/Care';
import Rooms from '../components/Rooms';
import Admission from '../components/forms/Admission';
import SearchPatientQrCode from '../components/forms/SearchPatientQrCode';
import Moment from "react-moment";
import moment from 'moment';
import dayjs from 'dayjs';
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import ExitPaper from '../components/ExitPaper';
import Invoice from '../components/Invoice';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Meta = Card.Meta;
var Hospitalization = function Hospitalization() {
  var ref = useRef();
  var _useParams = useParams(),
    command = _useParams.command;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isNewRoomVisible = _useState2[0],
    setIsNewRoomVisible = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isRoomsVisible = _useState4[0],
    setIsRoomsVisible = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isDataChanged = _useState6[0],
    setIsDataChanged = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showCare = _useState8[0],
    setShowCare = _useState8[1];
  var _useState9 = useState([]),
    _useState0 = _slicedToArray(_useState9, 2),
    rooms = _useState0[0],
    setRooms = _useState0[1];
  var _useState1 = useState(0),
    _useState10 = _slicedToArray(_useState1, 2),
    freeBedsCount = _useState10[0],
    setFreeBedsCount = _useState10[1];
  var _useState11 = useState(0),
    _useState12 = _slicedToArray(_useState11, 2),
    totalDeposit = _useState12[0],
    setTotalDeposit = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    history = _useState14[0],
    setHistory = _useState14[1];
  var _useState15 = useState(),
    _useState16 = _slicedToArray(_useState15, 2),
    selectedHospitalization = _useState16[0],
    setSelectedHospitalization = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    showInvoice = _useState18[0],
    setShowInvoice = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    showExitPaper = _useState20[0],
    setShowExitPaper = _useState20[1];
  var _useState21 = useState(moment().startOf('month').format()),
    _useState22 = _slicedToArray(_useState21, 2),
    from = _useState22[0],
    setFrom = _useState22[1];
  var _useState23 = useState(moment().endOf('month').format()),
    _useState24 = _slicedToArray(_useState23, 2),
    to = _useState24[0],
    setTo = _useState24[1];
  var _useState25 = useState(false),
    _useState26 = _slicedToArray(_useState25, 2),
    historyLoading = _useState26[0],
    setHistoryLoading = _useState26[1];
  var hcols = [{
    key: 'entry_mode',
    dataIndex: 'entry_mode',
    title: "Mode",
    render: function render(m) {
      return /*#__PURE__*/_jsxs("div", {
        children: [m == 0 && /*#__PURE__*/_jsx(Tag, {
          color: "#f50",
          children: "Urgence"
        }), m == 1 && /*#__PURE__*/_jsx(Tag, {
          color: "#409964",
          children: "Programm\xE9"
        }), m == 2 && /*#__PURE__*/_jsx(Tag, {
          color: "#996940",
          children: "Transfert"
        })]
      });
    }
  }, {
    key: 'date',
    dataIndex: 'date',
    title: "Entrée",
    render: function render(d) {
      return /*#__PURE__*/_jsx(Moment, {
        date: d,
        format: "DD/MM/YYYY"
      });
    }
  }, {
    key: 'idnumber',
    dataIndex: 'idnumber',
    title: "IDPatient",
    render: function render(t) {
      return /*#__PURE__*/_jsx("span", {
        children: t
      });
    }
  }, {
    key: 'name',
    dataIndex: 'name',
    title: "Patient",
    render: function render(d) {
      return /*#__PURE__*/_jsx("span", {
        children: d
      });
    }
  }, {
    key: 'pratician_name',
    dataIndex: 'pratician_name',
    title: "Médecin",
    render: function render(d) {
      return /*#__PURE__*/_jsx("span", {
        children: d
      });
    }
  }, {
    key: 'exit_time',
    dataIndex: 'exit_time',
    title: "Sortie",
    render: function render(d) {
      return /*#__PURE__*/_jsx(Moment, {
        date: d,
        format: "DD/MM/YYYY"
      });
    }
  }, {
    key: 'hospitalization',
    dataIndex: 'hospitalization',
    title: "",
    render: function render(h) {
      return /*#__PURE__*/_jsxs(Space, {
        direction: "horizontal",
        children: [/*#__PURE__*/_jsx(Button, {
          type: "link",
          onClick: function onClick() {
            setSelectedHospitalization(h);
            setShowExitPaper(true);
          },
          children: /*#__PURE__*/_jsx(Clipboard2Pulse, {
            size: 18
          })
        }), /*#__PURE__*/_jsx(Button, {
          type: "link",
          onClick: function onClick() {
            setSelectedHospitalization(h);
            setShowInvoice(true);
          },
          children: /*#__PURE__*/_jsx(CashStack, {
            size: 18
          })
        })]
      });
    }
  }];
  useEffect(function () {
    setIsDataChanged(false);
    axios.get(Common.baseApiUrl + 'getrooms/' + Common.currentUser.id.toString()).then(function (response) {
      if (response.data.status == 200) {
        setFreeBedsCount(0);
        setTotalDeposit(0);
        setRooms(response.data.rooms);
        response.data.rooms.forEach(function (r) {
          r.beds.forEach(function (b) {
            if (b.hospitalization == null) setFreeBedsCount(function (prev) {
              return prev + 1;
            });else setTotalDeposit(function (prev) {
              return prev + b.hospitalization.deposit;
            });
          });
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    })["finally"](function () {});
  }, [isDataChanged]);
  useEffect(function () {
    setIsDataChanged(false);
    setHistoryLoading(true);
    axios.get(Common.baseApiUrl + 'gethospitalizationhistory/' + from + "/" + to + "/" + Common.currentUser.id.toString()).then(function (response) {
      if (response.data.status == 200) {
        setHistory([]);
        response.data.hospitalizations.forEach(function (h) {
          var am = 0;
          h.bills.forEach(function (b) {
            am += b.total_amount;
          });
          setHistory(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              date: h.created_at,
              idnumber: h.customer && h.customer.idnumber,
              name: h.customer && h.customer.firstname + " " + h.customer.lastname,
              pratician_name: h.pratician_name,
              entry_mode: h.entry_mode,
              exit_time: h.exit_time,
              hospitalization: h,
              amount: am
            }]);
          });
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    })["finally"](function () {
      setHistoryLoading(false);
    });
  }, [isDataChanged, command]);
  useEffect(function () {
    if (command == 'care') setShowCare(true);
    if (command == 'rooms') setIsRoomsVisible(true);
  }, [command]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Space, {
      direction: "horizontal",
      wrap: true,
      children: [/*#__PURE__*/_jsx(Button, {
        type: "primary",
        icon: /*#__PURE__*/_jsx(Icon, {
          icon: "medical-icon:i-inpatient",
          width: "20",
          fill: "#CBDFB8",
          height: "20"
        }),
        onClick: function onClick() {
          setIsRoomsVisible(true);
        },
        children: /*#__PURE__*/_jsx("b", {
          children: "Gestion des salles"
        })
      }), /*#__PURE__*/_jsx(Button, {
        type: "primary",
        icon: /*#__PURE__*/_jsx(Icon, {
          icon: "medical-icon:care-staff-area",
          width: "20",
          fill: "#CBDFB8",
          height: "20"
        }),
        onClick: function onClick() {
          setShowCare(true);
        },
        children: /*#__PURE__*/_jsx("b", {
          children: "Soins"
        })
      })]
    }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          sm: 6,
          children: /*#__PURE__*/_jsx("div", {
            style: {
              background: "#FFFFFF",
              borderRadius: "4px",
              textAlign: "center",
              padding: "8px 10px"
            },
            children: /*#__PURE__*/_jsx(Statistic, {
              title: /*#__PURE__*/_jsx("b", {
                children: "Total salles"
              }),
              value: rooms.length
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          sm: 6,
          children: /*#__PURE__*/_jsx("div", {
            style: {
              background: "#FFFFFF",
              borderRadius: "4px",
              textAlign: "center",
              padding: "8px 10px"
            },
            children: /*#__PURE__*/_jsx(Statistic, {
              title: /*#__PURE__*/_jsx("b", {
                children: "Lits disponibles"
              }),
              value: freeBedsCount
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          sm: 6,
          children: /*#__PURE__*/_jsx("div", {
            style: {
              background: "#FFFFFF",
              borderRadius: "4px",
              padding: "8px 10px"
            },
            children: /*#__PURE__*/_jsx(Statistic, {
              title: /*#__PURE__*/_jsx("b", {
                children: "Total cautions"
              }),
              value: totalDeposit
            })
          })
        })]
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 8,
          md: 8,
          children: /*#__PURE__*/_jsx(Tabs, {
            animated: true,
            items: [{
              key: 1,
              label: /*#__PURE__*/_jsx("b", {
                children: "Admission"
              }),
              children: /*#__PURE__*/_jsx(_Fragment, {
                children: /*#__PURE__*/_jsx(Admission, {
                  handler: function handler() {
                    setIsDataChanged(true);
                  }
                })
              })
            }, {
              key: 2,
              label: /*#__PURE__*/_jsx("b", {
                children: "Historique"
              }),
              children: /*#__PURE__*/_jsx(_Fragment, {
                children: /*#__PURE__*/_jsx(Table, {
                  columns: hcols,
                  bordered: true,
                  sticky: true,
                  loading: historyLoading,
                  dataSource: history,
                  pagination: false
                })
              })
            }]
          })
        }), /*#__PURE__*/_jsx(Col, {
          children: /*#__PURE__*/_jsxs("div", {
            style: {
              background: "#F37C03",
              textAlign: "center",
              padding: "50px 12px 290px 12px",
              borderRadius: "7px"
            },
            children: [/*#__PURE__*/_jsx(SearchPatientQrCode, {}), /*#__PURE__*/_jsx(Icon, {
              icon: "medical-icon:i-inpatient",
              style: {
                color: "#EEE"
              },
              width: "112",
              height: "112"
            })]
          })
        })]
      })]
    }), /*#__PURE__*/_jsx(Modal, {
      title: /*#__PURE__*/_jsx("b", {
        style: {
          color: '#EEE'
        },
        children: " "
      }),
      destroyOnClose: true,
      footer: null,
      headerStyle: {
        background: '#2D3E4E',
        borderRadius: '0px',
        color: '#EEE'
      },
      open: isNewRoomVisible,
      onCancel: function onCancel() {
        setIsNewRoomVisible(false);
      },
      children: /*#__PURE__*/_jsx(AddRoom, {
        handler: function handler() {
          setIsNewRoomVisible(false);
          message.success({
            content: 'Opération réussie',
            delay: 4
          });
          setIsDataChanged(true);
        }
      })
    }), /*#__PURE__*/_jsx(Drawer, {
      maskClosable: false,
      centered: true,
      title: /*#__PURE__*/_jsxs(Space, {
        children: [/*#__PURE__*/_jsx(DoorOpenFill, {
          size: 20
        }), /*#__PURE__*/_jsx("b", {
          children: "Gestion des salles"
        })]
      }),
      destroyOnClose: true,
      width: "95%",
      footer: null,
      headerStyle: {
        background: '#2D3E4E',
        borderRadius: '0px',
        color: '#EEE'
      },
      open: isRoomsVisible,
      onClose: function onClose() {
        setIsRoomsVisible(false);
      },
      children: /*#__PURE__*/_jsx(Rooms, {})
    }), /*#__PURE__*/_jsx(Drawer, {
      title: /*#__PURE__*/_jsxs(Space, {
        children: [/*#__PURE__*/_jsx(Icon, {
          icon: "medical-icon:care-staff-area",
          width: "32",
          fill: "#CBDFB8",
          height: "32"
        }), /*#__PURE__*/_jsx("b", {
          children: " Soins patient"
        })]
      }),
      maskClosable: false,
      centered: true,
      destroyOnClose: true,
      width: "99%",
      headerStyle: {
        background: '#2D3E4E',
        borderRadius: '0px',
        color: '#EEE'
      },
      open: showCare,
      onClose: function onClose() {
        setShowCare(false);
      },
      children: /*#__PURE__*/_jsx(Care, {})
    }), selectedHospitalization && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Drawer, {
        title: /*#__PURE__*/_jsx("b", {
          children: "Fiche de sortie"
        }),
        width: "70%",
        open: showExitPaper,
        onClose: function onClose() {
          setShowExitPaper(false);
        },
        destroyOnClose: true,
        extra: [/*#__PURE__*/_jsx(ReactToPrint, {
          content: function content() {
            return ref.current;
          },
          children: /*#__PURE__*/_jsx(PrintContextConsumer, {
            children: function children(_ref) {
              var handlePrint = _ref.handlePrint;
              return /*#__PURE__*/_jsx(Button, {
                type: "primary",
                onClick: handlePrint,
                children: /*#__PURE__*/_jsx("b", {
                  children: "IMPRIMER"
                })
              });
            }
          })
        })],
        children: /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(ExitPaper, {
            hospitalization: selectedHospitalization
          })
        }, ref)
      }), /*#__PURE__*/_jsx(Drawer, {
        title: /*#__PURE__*/_jsxs("b", {
          style: {
            color: '#EEE'
          },
          children: ["Facture - ", selectedHospitalization.bed_label]
        }),
        destroyOnClose: true,
        width: "80%",
        headerStyle: {
          background: '#2D3E4E',
          borderRadius: '0px',
          color: '#EEE'
        },
        open: showInvoice,
        onClose: function onClose() {
          setShowInvoice(false);
        },
        extra: [/*#__PURE__*/_jsx(ReactToPrint, {
          content: function content() {
            return ref.current;
          },
          children: /*#__PURE__*/_jsx(PrintContextConsumer, {
            children: function children(_ref2) {
              var handlePrint = _ref2.handlePrint;
              return /*#__PURE__*/_jsx(Button, {
                type: "primary",
                onClick: handlePrint,
                children: /*#__PURE__*/_jsx("b", {
                  children: "IMPRIMER"
                })
              });
            }
          })
        })],
        children: /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(Invoice, {
            hospitalization: selectedHospitalization
          })
        }, ref)
      })]
    })]
  });
};
export default Hospitalization;